<template>
  <div class="w-50 mt-12px pr-12px">
    <div class="half-graph-container">
      <div
        class="
          d-flex
          justify-content-between
          align-items-center
          border-bottom
          px-2
          pb-2
        "
      >
        <div class="dashboardAdmin-cards-head ml-2">Recruiter Report</div>
        <div
          class="mr-2 pointer"
          @click="goToRecruiter()"
          v-if="roles.includes('GET_REPORT_RECRUITER')"
        >
          <img
            src="../../assets/New-imgs/landing-dashboard/redirect.svg"
            alt=""
          />
        </div>
      </div>

      <div
        style="margin: auto"
        v-if="recSpinner"
        class="d-flex justify-content-center align-items-center h-100"
      >
        <b-spinner label="Loading..."></b-spinner>
      </div>
      <div
        v-else-if="!recSpinner && noRecDataPercent"
        class="d-flex align-items-center justify-content-center w-100 h-100"
      >
        <img src="../../assets/ReportsNew/recDashboardNodata.svg" alt="" />
      </div>
      <!-- <div  v-else id="recGraph"></div> -->

      <div v-else class="d-flex h-90">
        <div style="width: 80%" class="h-100">
          <div id="recGraph" style="width: 100%; height: 100%"></div>
        </div>
        <div
          style="width: 20%"
          class="h-100 d-flex align-items-start justify-content-end m-3"
        >
          <div class="legend-container">
            <div
              class="d-flex align-items-center"
              v-for="(data, i) in recDataTransformed"
              :key="i + 'recData'"
            >
              <div
                class="legend-color-circle mr-1"
                :style="{ backgroundColor: data.colour }"
              ></div>
              <div class="legend-heading">{{ data.name }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { recGraphDash } from "../../utils/apiFunctions";
import { recAndVend } from "vue-d3-charts-hire3x";

export default {
  created() {
    this.getRecStats();
  },
  computed: {
    ...mapGetters(["roles"]),

    ...mapGetters("userVUEX", {
      roleValues: "getRoleValues",
      projectUsers: "getProjectUsers",
    }),
  },
  data() {
    return {
      recSpinner: true,
      recDataTransformed: [],
      noRecDataPercent: true,
      loopvar: 2,
    };
  },
  methods: {
    goToRecruiter() {
      this.$router.push({
        name: "RecruiterReport",
        query: {
          status: "dashboard",
        },
      });
    },
    areAllCountsZero(data, property) {
      return data.every((item) => item[property] === 0);
    },
    async getRecStats() {
      try {
        const payload = {
          userID: this.roleValues.userID,
        };
        const response = await recGraphDash(payload);
        if (response.status == 200) {
          const fixedResp = response.data.data;
          const colors = ["#F5D06E", "#4070EA", "#269C8A", "#595959"];
          if (fixedResp.length > 0) {
            let name = this.projectUsers;
            this.recDataTransformed = fixedResp.map((item, i) => {
              if (name[item._id]) {
                return {
                  name: name[item._id].username,
                  count: item.selectionRate,
                  colour: colors[i],
                };
              }
            });
            this.noRecDataPercent = this.areAllCountsZero(
              fixedResp,
              "selectionRate"
            );
            setTimeout(() => {
              if (document.getElementById("recGraph").innerHTML != "") {
                document.getElementById("recGraph").innerHTML = "";
              }

              let recStats = new recAndVend();
              const xAxisText = "Recruiters";
              recStats.verticalGraph(
                "#recGraph",
                colors,
                this.recDataTransformed,
                xAxisText
              );
            }, 200);
          }
        }
      } catch (error) {
        console.error(error);
      }
      this.recSpinner = false;
    },
  },
};
</script>

<style lang="postcss" scoped></style>
